import { createClient } from "@supabase/supabase-js"
import { env } from "./env.js"

/**
 * Supabase client configured for the agent_gate schema
 *
 * IMPORTANT: This client is configured to work with the agent_gate schema only.
 * Tables accessed through this client:
 * - users (for admin role management)
 *
 * Do NOT use "schema.table" notation with this client (e.g., "agent_gate.users")
 * Instead, use just the table name (e.g., "users")
 */
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  db: {
    schema: "agent_gate",
  },
})
